module.exports = __webpack_public_path__ + "assets/images/app-logo-dark-f508280203b7f50fa7ce1436cb76e6cc.png";